export const locales = ['ru', 'en', 'cs', 'uk', 'de', 'fr'] as const;
export const defaultLocale = 'ru' as const;

export type Locale = (typeof locales)[number];

// Native language names for UI display (language selector, settings)
export const localeNames: Record<Locale, string> = {
  ru: 'Русский',
  en: 'English',
  cs: 'Čeština',
  uk: 'Українська',
  de: 'Deutsch',
  fr: 'Français',
};

// Russian-language names for AI system prompts (LLM instructions)
export const localeNamesForPrompts: Record<Locale, string> = {
  ru: 'русском',
  en: 'английском',
  cs: 'чешском',
  uk: 'украинском',
  de: 'немецком',
  fr: 'французском',
};
